/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegistrazioneResDto } from '../../models/registrazione-res-dto';

export interface RegistrazioniControllerDeleteRegistrazione$Params {
  idRegistrazione: number;
}

export function registrazioniControllerDeleteRegistrazione(
  http: HttpClient,
  rootUrl: string,
  params: RegistrazioniControllerDeleteRegistrazione$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<RegistrazioneResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    registrazioniControllerDeleteRegistrazione.PATH,
    'delete',
  );
  if (params) {
    rb.path('idRegistrazione', params.idRegistrazione, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RegistrazioneResDto>;
      }),
    );
}

registrazioniControllerDeleteRegistrazione.PATH =
  '/admin/registrazione/id/{idRegistrazione}';
